export * from "./user";
export * from "./reissueToken";
export * from "./types";
export { default as createActionDataPlugin } from "./createActionDataPlugin";

declare global {
  interface Window {
    REAPackageVersions?: Record<string, string[]>;
  }
}
if (typeof window === "object") {
  window.REAPackageVersions = window.REAPackageVersions || {};
  window.REAPackageVersions["@realestate.com.au/user"] =
    window.REAPackageVersions["@realestate.com.au/user"] || [];
  window.REAPackageVersions["@realestate.com.au/user"].push(
    "__@realestate.com.au/user/version__",
  );
}
